//=================================================
// Cards
//=================================================
import { createInitializeOnce } from './utilities';

const initializeOnce = createInitializeOnce();

// Handle card swiping
function shiftCards(card, shuffle) {
    const width = card.offsetWidth;
    const left = parseInt(card.style.left) || 0;

    // Check if the card has be moved enough or if we're determined to shuffle
    if (Math.abs(left) > width / 2 || shuffle) {
        const cardRail = card.closest('.card-rail');
        const cards = cardRail.querySelectorAll('.card');

        // Re-index the other cards
        cards.forEach((otherCard) => {
            const { index } = otherCard.dataset;
            otherCard.setAttribute('data-index', index - 1);
        });

        // Set card to final index and animate the cards shuffling
        card.setAttribute('data-index', cards.length);
        card.style.transitionProperty = 'left, opacity';
        card.style.left = left > 0 ? '100vw' : '-100vw';
        card.style.opacity = 0;

        setTimeout(() => {
            card.style.transitionProperty = '';
            card.style.left = '';
            card.style.opacity = '';
        }, window.transitionDurationSlow);

        if (useAnalytics) {
            dataLayer.push({
                event: 'cards',
                label: 'swipe',
                value: 'true',
            });
        }
    } else {
        // Animate the card back to the starting position
        card.style.transitionProperty = 'left';
        card.style.left = '0px';

        setTimeout(() => {
            card.style.transitionProperty = '';
        }, window.transitionDurationSlow);
    }
}

// Determine if card swiping is active
function cardSwipeActive(card) {
    return window.isNavSmall && [1, '1'].includes(card.dataset.index);
}

export function setupCards() {
    document.querySelectorAll('.card-rail').forEach((cardRail) => {
        const cards = cardRail.querySelectorAll('.card');
        cards.forEach((card, i) => {
            if (!initializeOnce(card)) return;

            // Initialize card index values
            card.setAttribute('data-index', i + 1);

            // touch-action: pan-y allows the browser to handle vertical scroll natively
            // while letting JS handle horizontal swipes — no disableScroll needed
            card.style.touchAction = 'pan-y';

            card.addEventListener('pointerdown', (e) => {
                if (cardSwipeActive(card)) {
                    card.setAttribute('data-x', e.clientX);
                    card.setAttribute('data-y', e.clientY);
                    card.setAttribute('data-time', Date.now());
                    card.setAttribute('data-mode', 'normal');
                    // Capture pointer so mouse drag continues outside the element
                    if (e.pointerType === 'mouse') card.setPointerCapture(e.pointerId);
                }
            });

            card.addEventListener('pointermove', (e) => {
                if (!cardSwipeActive(card)) return;

                const threshold = 16;
                const x = e.clientX;
                const y = e.clientY;
                const xDiff = Math.abs(x - parseInt(card.dataset.x));
                const yDiff = Math.abs(y - parseInt(card.dataset.y));

                if (card.dataset.mode === 'normal') {
                    if (e.pointerType === 'mouse' && xDiff > 0) {
                        card.setAttribute('data-mode', 'swipe');
                    } else if (xDiff >= threshold && yDiff < threshold) {
                        card.setAttribute('data-mode', 'swipe');
                    } else if (yDiff >= threshold && xDiff < threshold) {
                        card.setAttribute('data-mode', 'scroll');
                    }
                }

                if (card.dataset.mode === 'swipe') {
                    card.style.left = `${ x - parseInt(card.dataset.x) }px`;
                }
            });

            card.addEventListener('pointerup', () => {
                if (cardSwipeActive(card) && card.dataset.mode !== 'scroll') {
                    const left = parseInt(card.style.left) || 0;
                    shiftCards(card, (parseInt(card.dataset.time) + 500 > Date.now()) && Math.abs(left) > 0);

                    // On mouse, the browser fires a click after pointerup — suppress it if the card was dragged
                    if (Math.abs(left) > 4) {
                        card.addEventListener('click', (e) => e.preventDefault(), { once: true, capture: true });
                    }
                }
                card.setAttribute('data-mode', 'normal');
            });

            card.addEventListener('pointercancel', () => {
                card.setAttribute('data-mode', 'normal');
                card.style.left = '0px';
            });

            // Analytics events
            if (useAnalytics) {
                card.addEventListener('click', () => {
                    dataLayer.push({
                        event: 'cards',
                        label: 'click',
                        value: card.getAttribute('href') || card.querySelector('a')?.getAttribute('href'),
                    });
                });
            }
        });
    });
}
